'use client';
import { MANIFEST_JS } from '../manifest/js.js';
import { getSameKeyValueMapForManifest, manifestResolve } from './manifest.utils.js';
import { SwanAssetFolders } from '../types/enums.js';

const SWAN_JS_KEY_MAP = getSameKeyValueMapForManifest(MANIFEST_JS);
function getSwanJsUrl(o, m, i) {
    return manifestResolve(MANIFEST_JS, o, SwanAssetFolders.JS, m, i);
}

export { SWAN_JS_KEY_MAP, getSwanJsUrl };
